const scopeKeys = [
  'latitude', 'longitude', 'zipcode', 'stateShortName', 'country', 'radius',
  'category', 'categoryId', 'businessId', 'expireSoon', 'local', 'global', 'sort',
];

export const buildSearchScope = (searchParams, location, viewport) => {
  const params = new URLSearchParams();
  const defaults = {
    latitude: location?.latitude, longitude: location?.longitude,
    zipcode: location?.zip, stateShortName: location?.region_code,
    country: location?.country_name,
  };
  scopeKeys.forEach((key) => {
    const value = defaults[key] ?? searchParams.get(key);
    if (value !== undefined && value !== null && value !== '') params.set(key, value);
  });
  if (searchParams.get('map') === '1') {
    params.set('local', 'true');
    ['latitude', 'longitude', 'radius'].forEach((key) => {
      const target = `map${key[0].toUpperCase()}${key.slice(1)}`;
      const value = viewport?.[key] ?? searchParams.get(target);
      if (value !== undefined && value !== null && value !== '') params.set(target, value);
    });
  }
  params.sort();
  return params.toString();
};

export const newSearchParams = (current, query, scope) => {
  const params = new URLSearchParams(current);
  if (scope) new URLSearchParams(scope).forEach((value, key) => {
    // Map queries force local eligibility without changing the user's ordinary filter.
    if (key === 'local' && params.get('map') === '1') return;
    params.set(key, value);
  });
  ['currentPage', 'autoCorrect', 'effectiveQuery', 'correctionQuery'].forEach((key) => params.delete(key));
  params.set('query', query);
  return params;
};

export const searchUrl = (endpoint, scope, values) => {
  const params = new URLSearchParams(scope);
  Object.entries(values).forEach(([key, value]) => params.set(key, value));
  return `/offer/${endpoint}?${params.toString()}`;
};

export const viewportFromSearchParams = (params) => {
  const latitude = Number(params.get('mapLatitude'));
  const longitude = Number(params.get('mapLongitude'));
  const radius = Number(params.get('mapRadius'));
  if (!params.has('mapLatitude') || !params.has('mapLongitude')
      || !Number.isFinite(latitude) || Math.abs(latitude) > 90
      || !Number.isFinite(longitude) || Math.abs(longitude) > 180
      || !Number.isFinite(radius) || radius <= 0) return null;
  return { latitude, longitude, radius };
};
